import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { teamRefreshLiveMatch } from '../redux/actions/Team';
import { isMatchLive } from '../service/liveMatch';

// A red card reaches the statistics at its minute, up to about five minutes
// after it was drawn, so a one-minute re-read is enough.
const LIVE_STRATEGY_MS = 60000;

// useLiveMatchPoll's endpoint answers null until full time, so sent-off players
// reach the strategy page only through GET /team/strategy. While a match is
// live, re-read it (teamRefreshLiveMatch keeps the board's lineup). `enabled` is
// false until the API sends Match Engine 2.5 fields, so with today's API this
// hook makes no requests.
export default function useLiveStrategyRefresh(matchRunning, enabled) {
  const dispatch = useDispatch();
  const isLive = isMatchLive(matchRunning);

  useEffect(() => {
    if (!enabled || !isLive) return undefined;
    const tick = () => {
      if (typeof document !== 'undefined' && document.hidden) return;
      dispatch(teamRefreshLiveMatch());
    };
    const interval = setInterval(tick, LIVE_STRATEGY_MS);
    const onVisibility = () => {
      if (!document.hidden) tick();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [dispatch, enabled, isLive]);
}
